import { BaseApiService } from "@mirage/services/BaseApiService";
import { IConsulteeService } from "@shared/publicportal/services/IConsulteeService";
import { VerifyConsulteeResult, VerifyRequest } from "@shared/mirage/core/contracts/User";
import { UserStore } from "@mirage/store/UserStore";
import { UserService } from "./UserService";

export class ConsulteeService extends BaseApiService implements IConsulteeService {
    constructor() {
        super("publicportal/consultee");
    }

    async verifyConsultee(request: VerifyRequest): Promise<VerifyConsulteeResult> {
        const response = await this.httpInstance().post("/verifyconsultee", request);

        const result = response.data as VerifyConsulteeResult;
        if (result.loginResult?.userId) {
            localStorage.setItem(
                "users.user",
                JSON.stringify({
                    id: result.loginResult.userId,
                    first_name: result.loginResult.userName,
                    last_name: result.loginResult.userLastName,
                    custom_properties: result.loginResult.userCustomProperties,
                    expiryDate: result.loginResult.expiryDate,
                    sessionTimeoutBuffer: result.loginResult.sessionTimeoutBuffer,
                } as UserStore)
            );
            UserService.SetLastAuthCheckResult(true);
        }
        return response.data;
    }
}
